import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@app/env';
import { Observable, map } from 'rxjs';

const API_URL = environment.apiProfessor;

export interface DataProd {
  DATAVERSAO: string;
}

@Injectable({
  providedIn: 'root',
})
export class DadosBuildService {
  private readonly http = inject(HttpClient);

  /**
   * /versao?PASTA=DIARIO
   *
   * endpoint para capturar a versao
   * pode ser usado tambem nas outras aplicacoes
   * PORTALTRANSPARENCIA
   * PREMATRICULA
   *
   * so trocar a pasta
   * @returns observable<Date>
   */
  getDadosBuild(): Observable<Date> {
    const params = new HttpParams().append('PASTA', 'DIARIO');

    return this.http.get<DataProd>(`${API_URL}/versao`, { params }).pipe(
      map((data) => {
        const dataString = data.DATAVERSAO;
        const partesDataHora = dataString.split(' ');
        const partesData = partesDataHora[0].split('/');
        const partesHora = partesDataHora[1].split(':');

        const ano = parseInt(partesData[2]);
        const mes = parseInt(partesData[1]) - 1;
        const dia = parseInt(partesData[0]);
        const horas = parseInt(partesHora[0]);
        const minutos = parseInt(partesHora[1]);

        return new Date(ano, mes, dia, horas, minutos);
      }),
    );
  }
}
